<ng-container *transloco="let translate">
	<base-modal #baseModal [showClose]="true" (closed)="_onModalClosed()">
		<div class="w-100 talign-c">
			<div class="w-100 fw-bold fs-xxl m-1-b">
				{{ translate('home.push_notifications.title') }}
			</div>
			<div class="w-100 fc-400 fs-xs lh-fs-l m-0h-t">
				{{ translate('home.push_notifications.description') }}
			</div>

			<div class="w-100 fl fl-ai-c fl-jc-c">
				<div style="width: 264px">
					<img
						class="left-as-is w-100"
						src="/assets/images/complete-registration/notifications.png"
						alt=""
					/>
				</div>
			</div>
		</div>

		<button ngProjectAs="[footer]" uiNewButtonFilled (click)="requestPermission()">
			{{ translate('general.continue') }}
		</button>
	</base-modal>
</ng-container>
